module.exports = __webpack_public_path__ + "img/undraw_warning_tl76.3c3ab27e.svg";